<div class="app-currency-exchange">
  <form nz-form nzLayout="vertical" class="app-currency-exchange-form" [formGroup]="form" (ngSubmit)="makePayment()">
    <app-image class="app-currency-exchange-form-main-icon" name="currency-exchange"></app-image>

    <nz-form-item>
      <nz-form-label translate>payment.payerAccount.label</nz-form-label>
      <nz-form-control>
        <app-account-select
          nzSize="large"
          [nzPlaceHolder]="'payment.payerAccount.placeholder' | translate: locale.language"
          [formControl]="payerAccountControl"
        ></app-account-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label translate>payment.amount.label</nz-form-label>
      <nz-form-control [nzExtra]="paymentFeeExtraTpl">
        <div class="app-currency-exchange-form-row app-currency-exchange-form-row-currency-select">
          <nz-input-number
            nzSize="large"
            (nzBlur)="onAmountFocusChange('initialAmount', false)"
            (nzFocus)="onAmountFocusChange('initialAmount', true)"
            [nzMin]="config.amountMin"
            [nzMax]="config.amountMax"
            [nzChangeOnWheel]="false"
            [nzParser]="CustomInputNumberParser"
            [nzPrecision]="config.amountPrecision"
            (keydown)="handleKeyDown($event)"
            [nzPlaceHolder]="'payment.amount.placeholder' | translate: locale.language"
            [error]="paymentConditions?.amountError"
            formControlName="initialAmount"
          >
          </nz-input-number>
          <app-currency [currencyCode]="initialCurrency" [showCode]="true"></app-currency>
        </div>
        <div class="ant-form-item-explain"></div>
      </nz-form-control>
      <ng-template #paymentFeeExtraTpl>
        @if (paymentConditions && paymentConditions.total && paymentConditions.fee) { @if (paymentConditions.tieredFeesApplied) { {{
        'payment.amount.extraWithTilde' | translate:locale.language: { total: paymentConditions.total.amount | currencySymbol: paymentConditions.total.currency
        | currencyRight, fee: paymentConditions.fee.amount | currencySymbol: paymentConditions.fee.currency | currencyRight } }} } @else { {{
        'payment.amount.extra' | translate:locale.language: { total: paymentConditions.total.amount | currencySymbol: paymentConditions.total.currency |
        currencyRight, fee: paymentConditions.fee.amount | currencySymbol: paymentConditions.fee.currency | currencyRight } }} } }
      </ng-template>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label translate>payment.amountYouGet.label</nz-form-label>
      <nz-form-control>
        <div class="app-currency-exchange-form-row app-currency-exchange-form-row-currency-select">
          <nz-input-number
            nzSize="large"
            (nzBlur)="onAmountFocusChange('amount', false)"
            (nzFocus)="onAmountFocusChange('amount', true)"
            [nzMin]="config.amountMin"
            [nzMax]="config.amountMax"
            [nzChangeOnWheel]="false"
            [nzParser]="CustomInputNumberParser"
            [nzPrecision]="config.amountPrecision"
            (keydown)="handleKeyDown($event)"
            [nzPlaceHolder]="'payment.amountYouGet.placeholder' | translate: locale.language"
            formControlName="amount"
          >
          </nz-input-number>
          <app-currency-select nzSize="large" [currencies]="currencies" [formControl]="currencyControl"></app-currency-select>
        </div>
        <div class="ant-form-item-explain"></div>
      </nz-form-control>
    </nz-form-item>

    <div class="app-currency-exchange-form-footer">
      @if (paymentConditions?.exchangeRate && form.valid) {
      <p
        [innerHTML]="'payment.exchangeRate.template' | translate:locale.language : { exchangeRate: paymentConditions.exchangeRate, initialCurrency:
        (paymentConditions.exchangeRateCurrencyPair.baseCurrency | currencyCodeSymbol), currency: (paymentConditions.exchangeRateCurrencyPair.quoteCurrency | currencyCodeSymbol) }"
      ></p>
      }

      <app-alert [form]="form"></app-alert>

      <button
        nz-button
        nzType="primary"
        nzSize="large"
        type="submit"
        [nzLoading]="submitButtonLoading$ | async"
        [disabled]="!form.valid || (submitButtonDisabled$ | async)"
        translate
      >
        payment.exchange
      </button>
    </div>
  </form>
</div>
